import { useNavigate } from "react-router";

import type { DealOpportunitiesLpListViewResponseV2 } from "@vega-api/generated/types/dealOpportunitiesLpListViewResponseV2";
import { m } from "@vega-core/paraglide/messages";
import { formatShortSlashDate } from "@vega-core/utils/formatDate";
import { FundLogos } from "@vega-modules/components/AssetClassLogos/AssetClassImages";
import { CoInvestmentFullPaths } from "@vega-modules/paths";

export type CoInvestmentItem = DealOpportunitiesLpListViewResponseV2;

type CoInvestmentRowProps = {
  item: CoInvestmentItem;
};

export const CoInvestmentRow = ({ item }: CoInvestmentRowProps) => {
  const navigate = useNavigate();
  // Temporarily commented out because not all GP (e.g. Apollo) will have asset classes: https://vegainvestments.atlassian.net/browse/VD-18007
  // const { formatAssetClassName } = useFormatAssetClass();

  const { deal, dealOpportunity } = item;

  const handleClick = () => {
    navigate(
      CoInvestmentFullPaths.CoInvestmentLpOverview.replace(
        ":id",
        dealOpportunity.id,
      ),
    );
  };

  return (
    <div
      className="grid grid-cols-1 xs:grid-cols-[1fr_1.1fr] gap-4 justify-between py-6 md:p-6 hover:bg-background/component cursor-pointer border-b border-border/primary first:border-t first:border-t-border/primary"
      data-testid="co-investment-row"
      onClick={handleClick}
    >
      <div className="flex items-center col-span-1 sm:flex-row gap-4 px-2 md:px-0">
        <div className="flex items-center justify-center">
          <FundLogos assetClass={deal.assetClass} bigSize />
        </div>
        <div className="flex flex-col gap-y-2">
          <p
            className="body-semi-large-semibold md:body-large-semibold truncate"
            data-testid="deal-name"
            title={deal.name}
          >
            {deal.name}
          </p>
          {/* Temporarily commented out because not all GP (e.g. Apollo) will have asset classes: https://vegainvestments.atlassian.net/browse/VD-18007 */}
          {/* <Tag data-testid="asset-class-tag">
            {formatAssetClassName(deal.assetClass)}
          </Tag> */}
        </div>
      </div>

      <div className="flex items-center px-2 sm:px-0 sm:justify-end">
        <div className="lg:text-right">
          <p className="body-small-regular text-text/secondary mb-1">
            {m.common_closingDate()}
          </p>
          <p
            className="body-semi-large-semibold text-text/primary"
            data-testid="closing-date"
          >
            {deal.closingDate ? formatShortSlashDate(deal.closingDate) : "-"}
          </p>
        </div>
      </div>
    </div>
  );
};
